import { nanoid } from 'nanoid'

export * from './collection'
export * from './array'
export * from './bet'
export * from './bonus'
export * from './market'
export * from './outcome'
export * from './merge'
export * from './func'
export * from './status'
export * from './counters'
export * from './date'
export * from './iso'
export * from './cms'
export * from './defer'
export * from './feed'

export { default as logger } from './logger'

export function isEventIdsEqual (idA, idB) {
  return (idA + '') === (idB + '')
}

export const getIntUID = () => (
  Math.floor(Math.random() * 1e6)
)

export const getUID = (size = 5) => nanoid(size)

export function isComponent (type) {
  // React.Component subclasses have this flag
  return (
    Boolean(type.prototype) &&
    Boolean(type.prototype.isReactComponent)
  )
}

export const centsToDecimal = (amount, currency, fix = true) => {
  let processedAmount = amount
  if (!processedAmount) {
    processedAmount = 0
  }
  processedAmount = Number(processedAmount) / 100
  if (fix) {
    return `${processedAmount.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}${currency ? ` ${String(currency || '')}` : ''}`
  }
  return processedAmount
}

export const getUniqueCount = (arr, key) => (key
  ? new Set(arr.map((item) => item[key])).size
  : new Set(arr).size)
